import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34; // 00:17:34
const TOTAL_SPOTS = 100;
const START_SPOTS = 7;
const MIN_SPOTS = 3;
const startedAt = Date.now();

export type OfferClock = {
  hours: string;
  minutes: string;
  seconds: string;
  display: string;
  spotsLeft: number;
  totalSpots: number;
};

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

export function useOfferClock(): OfferClock {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = Math.floor((now - startedAt) / 1000);
  const remaining = DURATION_SECONDS - (elapsed % (DURATION_SECONDS + 1));
  const h = Math.floor(remaining / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = remaining % 60;
  const spotsLeft = Math.max(MIN_SPOTS, START_SPOTS - Math.floor(elapsed / 75));

  return {
    hours: pad(h),
    minutes: pad(m),
    seconds: pad(s),
    display: `${pad(h)}:${pad(m)}:${pad(s)}`,
    spotsLeft,
    totalSpots: TOTAL_SPOTS,
  };
}
